export default "__VITE_ASSET__DgbODoa9__"